export function createTestIdFunc(base) {
    return (part) => [base, part].filter(Boolean).join('-');
}
//# sourceMappingURL=attribute.js.map